import React, {useContext, useEffect, useState} from 'react';
import Sidebar from "../components/Sidebar";
import {Box} from '@mui/material';
import Grid from '@mui/material/Grid2';
import Typography from "@mui/material/Typography";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {csCZ as datePickersCsCZ} from "@mui/x-date-pickers/locales";
import {csCZ as dataGridCsCZ} from "@mui/x-data-grid/locales";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import CircularProgress from '@mui/material/CircularProgress';
import {Link} from "react-router-dom";
import {GlobalDataContext} from "../components/GlobalDataProvider";
import {DataGridPro, gridClasses, useGridApiRef} from "@mui/x-data-grid-pro";
import {groupsAndActivitiesColumns, groupsAndActivitiesGroupingModel} from "../data/DatatableColumns";
import {RefreshButton} from "../components/RefreshButton";
import {convertDateToMMYYDayjs, convertMMYYToDate} from "../utils/Coverter";
import {
  generateHiddenColumns,
  generateMonthArray,
  generateThisYearFirstMMYY,
  generateThisYearLastMMYY
} from "../utils/ValueGenerator";
import {createGroupAccountBalance} from "../utils/GroupsActivities";
import dayjs from "dayjs";
import {CustomToolbar, useFilteredColumns} from "../components/CustomToolbar";
export default function Activities() {
  const {groupsAndActivitiesCompanies} = useContext(GlobalDataContext);
  const {updateMessage} = useContext(GlobalDataContext);
  const [businessMonthFrom, setBusinessMonthFrom] = useState(generateThisYearFirstMMYY());
  const [businessMonthTo, setBusinessMonthTo] = useState(generateThisYearLastMMYY());
  const [dateError, setDateError] = useState("");
  const [months, setMonths] = useState([]);
  const [rows, setRows] = useState([]);
  const columns = useFilteredColumns(() => groupsAndActivitiesColumns(months));
  const [hiddenColumns, setHiddenColumns] = useState({});
  const apiRef = useGridApiRef();
  const getTreeDataPath = (row) => row.hierarchy;


  useEffect(() => {
    if (groupsAndActivitiesCompanies && groupsAndActivitiesCompanies.length > 0) {
      setMonths(generateMonthArray(businessMonthFrom, businessMonthTo));
    }
  }, [businessMonthFrom, businessMonthTo, groupsAndActivitiesCompanies]);

  useEffect(() => {
    if (groupsAndActivitiesCompanies && groupsAndActivitiesCompanies.length > 0 && months && months.length > 0) {
      const rows = prepareRows(groupsAndActivitiesCompanies);
      setRows(rows)
    }
  }, [months]);

  const groupingColDef = {
    headerName: 'Firma',
    minWidth: 250,
    hideDescendantCount: true,
  };

  const dataTypeTranslations = {
    incomes: "Příjmy",
    outcomes: "Výdaje",
    dph: "DPH",
    investments: "Investice",
    sale: "Prodej",
    rent: "Pronájem",
    loanBank: "Půjčka - banka",
    loanGroup: "Půjčka - skupina",
    "auto-generated-row-null/DEVELOPMENT-null/NOHO Tangata s.r.o.": "Příjmy",
  };

  function translateDataType(dataType) {
    return dataTypeTranslations[dataType] || dataType;
  }

  const prepareRows = (data) => {
    const dataTypes = ["outcomes", "incomes", "dph", "investments", "loanBank", "loanGroup"];
    const rows = [];
    const overallSums = initializeOverallSums(dataTypes, months);
    const totalSums = initializeTotalSums(dataTypes);
    const groupAccountBalance = createGroupAccountBalance(data);

    console.log(data)

    data.forEach(entry => {
      processDataEntry(entry, dataTypes, groupAccountBalance, months, overallSums, totalSums, rows);
    });

    dataTypes.forEach(dataType => {
      addSummaryRow(dataType, months, overallSums, totalSums, rows);
    });

    addCashFlowRow(months, overallSums, totalSums, rows);

    calculateGroupMonthlyBalancesAndCreateRows(data, rows);

    sortRows(rows);

    return rows;
  };
  const calculateGroupMonthlyBalancesAndCreateRows = (data, rows) => {
    const groupBalances = {};

    data.forEach(entry => {
      const group = entry.group;

      if (!groupBalances[group]) {
        groupBalances[group] = {};
      }

      Object.keys(entry.monthlyBalances).forEach(month => {
        if (!groupBalances[group][month]) {
          groupBalances[group][month] = 0;
        }
        groupBalances[group][month] += entry.monthlyBalances[month];
      });
    });


    Object.keys(groupBalances).forEach(group => {
      const row = {
        id: group,
        hierarchy: [group],
      };

      Object.entries(groupBalances[group]).forEach(([month, balance]) => {
        row[month] = balance;
      });

      rows.push(row);
    });

  };

  const initializeOverallSums = (dataTypes, months) => {
    const sums = {};
    months.forEach(month => {
      sums[`assumptions_${month}`] = {};
      sums[`spendings_${month}`] = {};
      dataTypes.forEach(type => {
        sums[`assumptions_${month}`][type] = 0;
        sums[`spendings_${month}`][type] = 0;
      });
    });
    return sums;
  };

  const initializeTotalSums = (dataTypes) => {
    const sums = {};
    dataTypes.forEach(type => {
      sums[type] = {
        sumAssumptions: 0,
        sumReality: 0,
        totalAssumptionValues: 0,
        totalValues: 0
      };
    });
    return sums;
  };

  const processDataEntry = (entry, dataTypes, groupAccountBalance, months, overallSums, totalSums, rows) => {
    const monthlyBalances = {
      id: entry.id,
      hierarchy: [entry.group, entry.name],
    };


    Object.entries(entry.monthlyBalances).forEach(([month, balance]) => {
      monthlyBalances[month] = balance;
    });

    rows.push(monthlyBalances);
    dataTypes.forEach(dataType => {
      const row = createRow(entry, dataType, groupAccountBalance, months, overallSums, totalSums);
      rows.push(row);
    });
  };

  const createRow = (entry, dataType, groupAccountBalance, months, overallSums, totalSums) => {
    const row = {
      id: `${entry.id}-${dataType}`,
      hierarchy: [
        `${entry.group}`,
        `${entry.name}`,
        translateDataType(dataType)
      ]
    };

    let sumAssumptions = 0;
    let sumReality = 0;

    months.forEach(month => {
      const { assumptionData, monthlyData } = entry;
      const assumptionValue = (assumptionData[month] && assumptionData[month][dataType]) || 0;
      const realityValue = (monthlyData[month] && monthlyData[month][dataType]) || 0;

      row[`assumptions_${month}`] = assumptionValue;
      row[`spendings_${month}`] = realityValue;

      sumAssumptions += assumptionValue;
      sumReality += realityValue;

      overallSums[`assumptions_${month}`][dataType] += assumptionValue;
      overallSums[`spendings_${month}`][dataType] += realityValue;
    });

    row['sum_assumptions'] = sumAssumptions;
    row['sum_reality'] = sumReality;

    row['total_assumption_values'] = entry.totalAssumptionValues[dataType] || 0;
    row['total_values'] = entry.totalValues[dataType] || 0;

    totalSums[dataType].sumAssumptions += sumAssumptions;
    totalSums[dataType].sumReality += sumReality;
    totalSums[dataType].totalAssumptionValues += row['total_assumption_values'];
    totalSums[dataType].totalValues += row['total_values'];

    return row;
  };

  const addSummaryRow = (dataType, months, overallSums, totalSums, rows) => {
    const sumRow = { id: `sum-${dataType}`, hierarchy: ["Celkem", translateDataType(dataType)] };
    let totalSumAssumptions = 0;
    let totalSumReality = 0;

    months.forEach(month => {
      sumRow[`assumptions_${month}`] = overallSums[`assumptions_${month}`][dataType];
      sumRow[`spendings_${month}`] = overallSums[`spendings_${month}`][dataType];
      totalSumAssumptions += overallSums[`assumptions_${month}`][dataType];
      totalSumReality += overallSums[`spendings_${month}`][dataType];
    });

    sumRow['sum_assumptions'] = totalSumAssumptions;
    sumRow['sum_reality'] = totalSumReality;
    sumRow['total_assumption_values'] = totalSums[dataType].totalAssumptionValues;
    sumRow['total_values'] = totalSums[dataType].totalValues;

    rows.push(sumRow);
  };

  const addCashFlowRow = (months, overallSums, totalSums, rows) => {
    const cashFlowRow = { id: 'cashFlow', hierarchy: ["Čistý finanční tok"] };
    let totalCashFlowAssumptions = 0;
    let totalCashFlowReality = 0;

    months.forEach(month => {
      const incomesAssumptions = overallSums[`assumptions_${month}`]['incomes'] || 0;
      const outcomesAssumptions = overallSums[`assumptions_${month}`]['outcomes'] || 0;
      const incomesReality = overallSums[`spendings_${month}`]['incomes'] || 0;
      const outcomesReality = overallSums[`spendings_${month}`]['outcomes'] || 0;

      const cashFlowAssumptions = incomesAssumptions + outcomesAssumptions;
      const cashFlowReality = incomesReality + outcomesReality;

      cashFlowRow[`assumptions_${month}`] = cashFlowAssumptions;
      cashFlowRow[`spendings_${month}`] = cashFlowReality;

      totalCashFlowAssumptions += cashFlowAssumptions;
      totalCashFlowReality += cashFlowReality;
    });

    cashFlowRow['sum_assumptions'] = totalCashFlowAssumptions;
    cashFlowRow['sum_reality'] = totalCashFlowReality;
    cashFlowRow['total_assumption_values'] = totalSums['incomes'].totalAssumptionValues + totalSums['outcomes'].totalAssumptionValues;
    cashFlowRow['total_values'] = totalSums['incomes'].totalValues + totalSums['outcomes'].totalValues;

    rows.push(cashFlowRow);
  };

  const sortRows = (rows) => {
    rows.sort((a, b) => {
      const aHierarchy = a.hierarchy[0];
      const bHierarchy = b.hierarchy[0];

      if (aHierarchy === 'Celkem' || aHierarchy === 'Čistý finanční tok') return 1;
      if (bHierarchy === 'Celkem' || bHierarchy === 'Čistý finanční tok') return -1;

      if (aHierarchy === 'Prázdná skupina') return 1;
      if (bHierarchy === 'Prázdná skupina') return -1;

      return aHierarchy.localeCompare(bHierarchy);
    });
  };

  const handleDateFromChange = (newValue) => {
    if (!newValue) {
      setBusinessMonthFrom(null);
      return
    }
    setBusinessMonthFrom(convertDateToMMYYDayjs(newValue.toString()));
    const dayjsFrom = dayjs(newValue);
    const dayjsTo = convertMMYYToDate(businessMonthTo);
    if (dayjsTo.isBefore(dayjsFrom)) {
      setDateError("Datum od musí být před datumem do!");
    } else {
      setDateError(null);
    }
  };
  const handleDateToChange = (newValue) => {
    if (!newValue) {
      setBusinessMonthTo(null);
      return;
    }
    setBusinessMonthTo(convertDateToMMYYDayjs(newValue.toString()));
    const dayjsFrom = convertMMYYToDate(businessMonthFrom);
    const dayjsTo = dayjs(newValue);
    if (dayjsTo.isBefore(dayjsFrom)) {
      setDateError("Datum od musí být před datumem do!");
    } else {
      setDateError(null);
    }
  };


  useEffect(() => {
    const newHiddenColumns = generateHiddenColumns(months);
    setHiddenColumns(newHiddenColumns);

    if (apiRef.current && groupsAndActivitiesCompanies && groupsAndActivitiesCompanies.length > 0 && months.length > 0 && rows.length > 0 ) {
      apiRef.current.setState((prevState) => ({
        ...prevState,
        columns: {
          ...prevState.columns,
          columnVisibilityModel: newHiddenColumns,
        },
      }));
      apiRef.current.forceUpdate();
    }
  }, [months]);

  return (
    <Sidebar>
      <Grid container justifyContent="start">
        <Grid size={6}>
      <Typography variant="h5" fontWeight={600}>Data podle činností</Typography>
        </Grid>
        <Grid size={6} textAlign="right" sx={{height: '200%'}}>
          <Typography variant="text">
            {updateMessage}
          </Typography>
        </Grid>
        <Grid size={6}>
      <Typography variant="h7" fontWeight={400}>
        <Link to="/home" style={{textDecoration: 'none', color: 'black'}}>NOHO</Link> -> Činnosti
      </Typography>
        </Grid>
          <Grid size={6} textAlign="right">
            <RefreshButton/>
          </Grid>
        </Grid>
      <Box sx={{width: "100%", marginTop: "10px", backgroundColor: '#f5f5f5', padding: 2, marginBottom: 2}}>
        <Grid container>
          <Grid size={12}>
            <LocalizationProvider adapterLocale="cs" dateAdapter={AdapterDayjs}
                                  localeText={datePickersCsCZ.components.MuiLocalizationProvider.defaultProps.localeText}>
              <DatePicker
                label="Od"
                views={['year', 'month']}
                value={convertMMYYToDate(businessMonthFrom)}
                maxDate={convertMMYYToDate(businessMonthTo)}
                onChange={handleDateFromChange}
                slotProps={{
                  textField: {
                    onFocus: () => setBusinessMonthFrom(null),
                  },
                }}
                sx={{
                  width: "220px",
                  marginRight: "15px",
                  backgroundColor: "white",
                  borderRadius: "4px",
                }}
              />
              <DatePicker
                label="Do"
                views={['year', 'month']}
                value={convertMMYYToDate(businessMonthTo)}
                minDate={convertMMYYToDate(businessMonthFrom)}
                onChange={handleDateToChange}
                slotProps={{
                  textField: {
                    onFocus: () => setBusinessMonthTo(null),
                  },
                }}
                sx={{width: "220px", marginRight: "15px", backgroundColor: "white", borderRadius: "4px"}}
              />
            </LocalizationProvider>
          </Grid>
          <Grid size={12} p={0.5} pb={0}>
            <Typography variant="text" sx={{ color: 'red'}}>
              {dateError}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      {
        groupsAndActivitiesCompanies && groupsAndActivitiesCompanies.length > 0 && months.length > 0 && rows.length > 0 ? (
          <div style={{height: "78vh", width: '100%'}}>
            <DataGridPro
              treeData
              getTreeDataPath={getTreeDataPath}
              rows={rows}
              apiRef={apiRef}
              columns={columns}
              disableColumnReorder
              searchBar={true}
              initialState={{
                ...rows.initialState,
                pinnedColumns: {
                  left: ["__tree_data_group__"],
                  right: ['sum_assumptions', 'sum_reality', 'total_assumption_values', 'total_values'],
                },
                columns: {
                  columnVisibilityModel: {
                    ...hiddenColumns,
                  },
                }
              }}
              hideFooter
              localeText={dataGridCsCZ.components.MuiDataGrid.defaultProps.localeText}
              groupingColDef={groupingColDef}
              columnGroupingModel={groupsAndActivitiesGroupingModel(months)}
              slots={{toolbar: CustomToolbar}}
              getCellClassName={(params) => {
                let classNames = '';

                if (params.value < 0) {
                  classNames += 'negative ';
                }

                if (params.colDef.headerName.includes("Skutečnost") && (params.rowNode.groupingKey.includes("Celkem") || params.rowNode.parent.includes("Celkem"))) {
                  classNames += 'spendings-total ';
                }
                if (params.colDef.headerName.includes("Skutečnost") && params.id.includes("cashFlow")) {
                  classNames += 'spendings-cashflow ';
                }

                  classNames += 'spendings ';

                if (params.rowNode.groupingKey.includes("Celkem") || params.rowNode.parent.includes("Celkem")) {
                  classNames += 'total ';
                }
                if (params.id.includes("cashFlow")) {
                  classNames += 'cashflow ';
                }

                return classNames.trim();
              }}
              sx={{
                '&.MuiDataGrid-root': {
                  borderRadius: '0px',
                  borderLeft: 'none',
                  borderRight: 'none',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 'bold', overflow: 'visible',
                },
                '& .MuiDataGrid-columnHeader': { borderRight: '1px solid rgba(224, 224, 224, 1)' },
                '& .spendings': {
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                },
                '& .total': {
                  fontWeight: 'bold',
                },
                '& .cashflow': {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                },
                '& .spendings-cashflow': {
                  fontWeight: 'bold',
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                  backgroundColor: '#f5f5f5',
                },
                '& .spendings-total': {
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                  fontWeight: 'bold',
                },
                '& .MuiDataGrid-cell.negative': {
                  color: 'red',
                },
                [`.${gridClasses.cell}.pinned-row`]: {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                },
                [`.${gridClasses.cell}.pinned-row_spendings`]: {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                },
                [`.${gridClasses.cell}.spendings`]: {
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                },
              }}
            />

          </div>

        ) : (
          <CircularProgress sx={{position: 'absolute', top: '50%', left: '50%'}}/>
        )
      }
    </Sidebar>
  );
}
